import { render, staticRenderFns } from "./patrolTaskList.vue?vue&type=template&id=244d0fd6&scoped=true"
import script from "./patrolTaskList.vue?vue&type=script&lang=js"
export * from "./patrolTaskList.vue?vue&type=script&lang=js"
import style0 from "./patrolTaskList.vue?vue&type=style&index=0&id=244d0fd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d0fd6",
  null
  
)

export default component.exports